import React from 'react';

// project import
import Tooltip from '@mui/material/Tooltip';
import IconButton from 'components/@extended/IconButton';
import { ButtonVariantProps } from 'types/extended';

type SmallIconButtonProps = {
   sx?: any,
   className?: any,
   status?: string,
   tooltipText?: string | "",
   children: React.ReactElement,
   onClick?: (event: any) => void,
   orientation?: string,
   variant?: ButtonVariantProps
   disabled?: boolean
   loading?: boolean
}
 
const SmallIconButton = (props: SmallIconButtonProps) => {
   const isDisabled = props.status === "disabled" || props.disabled || props.loading;

   const icon = React.cloneElement(props.children, {
      color: isDisabled ? 'disabled' : ((props.variant && props.variant === "text") ? "secondary" : "primary")
   });

   return (
      <Tooltip title={props.tooltipText} placement={props.orientation === 'vertical' ? "right" : "bottom"}>
         <div className={props.className} id={'id-' + props.className}>
            <IconButton
               id={'button-id-' + props.className}
               variant={props.variant ? props.variant : "light"}
               color="secondary"
               sx={props.sx}
               onClick={props.onClick}
               disabled={isDisabled}
               className={'button-' + props.className}
               loading={props.loading}
            >
               {icon}
            </IconButton>
         </div>
      </Tooltip>
   )
}

export default SmallIconButton;
